import { atom } from 'recoil';
import { IReuniao } from '../../commons/types/crm';

export const reunioesAtom = atom({
  key: 'reunioes',
  default: localStorage.getItem('usuario')
    ? (JSON.parse(localStorage.getItem('usuario')!) as IReuniao[])
    : null,
});
